<template>
  <aw-drag
    :enable="bcDocumentStore.edit"
    :drag-item="element"
    #default="{ dragHandle }"
    class="ColorList__Row items-center"
  >
    <div class="relative flex">
      <span
        :ref="dragHandle"
        class="Mover absolute -left-5 md:-left-8 -top-0 cursor-move text-gray-500 hover:text-gray-800"
        v-if="edit"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
      </span>

      <contenteditable
        tag="span"
        v-model="data.name"
        :noNL="true"
        :contenteditable="edit"
        :noHTML="true"
        :alwaysSelectAll="$t('name')"
        @updated="updated = 'name'"
        :auto-focus="!element.id"
        class=""
      />
    </div>
    <aw-copy-to-clipboard 
      :text="data.value"
      v-slot="{copy, status}"
    >
      <contenteditable
        tag="div"
        v-model="data.value"
        :noNL="true"
        :contenteditable="edit"
        :noHTML="true"
        :alwaysSelectAll="$t('value')"
        @updated="updated = 'value'"
        class="ColorList__Row__Value px-2"
      />
      <div class="AwClipboard__Icon w-3 h-full">
        <aw-icon 
          v-show="status !== 'copied'"
          icon="clipboard-copy" 
          class="w-3 h-3 -mt-1 text-gray-400 hover:text-bc-blue cursor-pointer"
          @click="copy()"
        />
      </div>
    </aw-copy-to-clipboard>
    <span
      v-if="edit"
      @click="deleteRow()"
      class="ml-auto text-lg cursor-pointer"
      >x</span
    >
  </aw-drag>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'
import UpdateDocumentRevision from '../../mixins/actions/UpdateDocumentRevision'

export default {
  mixins: [BaseElement],
  methods: {
    async deleteRow() {
      const $router = this.$router
      const bcSelectedStore = this.bcSelectedStore
      const bcDocumentStore = this.bcDocumentStore
      bcDocumentStore.deleteElementsRecursive([this.element.id])
      await bcDocumentStore.deleteElements([this.element], async (documentRev, resolve) => {
        if (documentRev.id !== bcDocumentStore.documentRev) {
          await UpdateDocumentRevision(bcDocumentStore, documentRev.id, $router)
        } else {
          bcSelectedStore.reload()
        }

        resolve()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.ColorList__Row .AwClipboard__Icon svg {
  visibility: hidden;
  opacity: 0;
  transition:  opacity 150ms ease-in-out;
}

.ColorList__Row:has(.ColorList__Row__Value:hover) .AwClipboard__Icon svg,
.ColorList__Row:has(.AwClipboard__Icon:hover) .AwClipboard__Icon svg {
  visibility: visible;
  opacity: 1;
}
</style>
